export default __webpack_public_path__ + "static/media/synapse_example.1b60dcec.png";